import React, { Component } from 'react';
import { CategoryScale, Chart as ChartJS, ChartData, ChartOptions, Filler, Legend, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { ChartJsDataModel } from '../../../domain/chart/ChartDomains';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend);

class LineChartComponent extends Component<Props> {
  public render() {
    const { data, options } = this.props;
    if (options?.maintainAspectRatio) options.maintainAspectRatio = false;
    console.log(data);
    return <Line options={options} data={data}></Line>;
  }
}

interface Props {
  data: ChartJsDataModel | ChartData<'line'>;
  options?: ChartOptions;
}

export default LineChartComponent;
